export enum Category {
  HUMAN = 'HUMAN',
  SCENERY = 'SCENERY',
  TRIPTYPES = 'TRIP-TYPES'
}
